<template>
  <section class="show-all-titles">
    <h3
      class="xs:pl-0 pl-[0.813rem]"
      :class="profileFollowers?.length < 9 ? 'pb-4' : ''"
    >
      <!-- <span class="md:hidden inline-block h1-titles has-show-more">
        {{ $t("profiles.labels.followers") }}
      </span> -->

      <span class="md:block hidden text-base h3-titles has-show-more">
        {{
          $t("wegow.profile.followersTitle" + type, {
            people: followersCount
          })
        }}
      </span>
    </h3>
    <button
      v-if="profileFollowers?.length > 9"
      class="text-color-topaz-light text-sm"
      @click="$emit('openFollowers')"
    >
      {{ $t("general.header.dropdown.showAll") }}
    </button>
  </section>
  <section v-if="profileFollowers?.length > 0 && isAuth" class="user-card">
    <user-card
      v-for="follower in profileFollowersFormatter"
      :key="follower.id"
      :user="follower"
    />
  </section>
  <section
    v-if="profileFollowers?.length > 0 && isAuth"
    class="lg:hidden block"
  >
    <carousel
      class="carousel fixed-carousel-arrows"
      :wrap-around="false"
      :transition="500"
      :breakpoints="BREAKPOINTS.eventProfileRelated"
    >
      <slide
        v-for="(follower, index) in profileFollowers"
        :key="follower.id"
        :aria-hidden="false"
      >
        <profile-card
          :profile="follower"
          type="profile-sm-card"
          :class="{ 'xs:ml-0 ml-[0.813rem]': index === 0 }"
        />
      </slide>
      <template #addons>
        <!-- <navigation /> -->
      </template>
    </carousel>
  </section>

  <div
    v-else-if="profileFollowers?.length === 0 && isAuth"
    class="xs:pl-0 pl-[0.813rem]"
  >
    <p class="text-m">
      {{ $t("wegow.profile.sections.events.noUser") }}
    </p>
  </div>
  <div v-else class="follow">
    <fake-followers :type="'venue'" />
  </div>
</template>

<script setup>
import { computed } from "vue";

import UserCard from "@/components/general/ui/UserCard.vue";
import ProfileCard from "@/components/wegow/ui/cards/ProfileCard.vue";
import FakeFollowers from "@/components/wegow/ui/FakeFollowers.vue";

import { useUser } from "@/composables/useUser";

import { BREAKPOINTS } from "@/constants.js";

import { Carousel, Navigation, Slide } from "vue3-carousel";

const { isAuth } = useUser();
const props = defineProps({
  profileFollowers: {
    type: Array,
    default: undefined
  },
  followersCount: {
    type: Number,
    default: 0
  },
  type: {
    type: String,
    default: "Event"
  }
});
const emit = defineEmits(["openFollowers"]);
const profileFollowersFormatter = computed(() => {
  let followersFormat = props.profileFollowers.slice(0, 9);
  return followersFormat;
});
</script>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
.user-card {
  display: none;
  @media screen and (min-width: $screen-lg) {
    display: grid;
    grid-template-columns: repeat(3, 100px);
    gap: 0.75rem; // 12px
    overflow: hidden;
    position: relative;
  }
}
</style>
